import SearchBar from "@/components/searchbar";
import Throbber from "@/components/throbber";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useChangePassword } from "@/hooks/use-mutations";
import { zodResolver } from "@hookform/resolvers/zod";
import { ArrowLeft } from "lucide-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";

const formSchema = z
  .object({
    currentPassword: z
      .string()
      .min(8, "Password should be at least 8 characters"),
    newPassword: z.string().min(8, "Password should be at least 8 characters"),
    confirmNewPassword: z
      .string()
      .min(8, "Password should be at least 8 characters"),
    otp: z.string().min(1),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Passwords don't match",
    path: ["confirmNewPassword"],
  });

const ChangePassword = () => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      otp: "",
    },
  });
  const navigate = useNavigate();

  const { mutateAsync: changePassword, isPending } = useChangePassword({
    onSuccess: () => {
      navigate("/dashboard");
    },
  });
  const onSubmit = (data) => {
    changePassword({
      password: data.currentPassword,
      newPassword: data.newPassword,
      otp: data.otp,
    });
  };

  return (
    <div>
      {/* header */}
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="bg-primary-50 hover:bg-primary-50/90 flex size-8 items-center justify-center rounded-md"
          >
            <ArrowLeft className="size-6" />
          </button>
          <span className="hidden lg:inline">Change Password</span>
        </div>

        <SearchBar />
      </header>

      <div className="mt-6">
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="mx-auto mt-8 max-w-120"
        >
          <Form {...form}>
            <FormField
              control={form.control}
              name="currentPassword"
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Current Password</FormLabel>
                  <FormControl>
                    <Input
                      className={"px-4 py-2.5 lg:w-full"}
                      type={"password"}
                      {...field}
                      placeholder="**********"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="newPassword"
              render={({ field }) => (
                <FormItem className="mt-4 flex flex-col">
                  <FormLabel>New Password</FormLabel>
                  <FormControl>
                    <Input
                      className={"px-4 py-2.5 lg:w-full"}
                      type={"password"}
                      {...field}
                      placeholder="**********"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="confirmNewPassword"
              render={({ field }) => (
                <FormItem className="mt-4 flex flex-col">
                  <FormLabel>Confirm New Password</FormLabel>
                  <FormControl>
                    <Input
                      className={"px-4 py-2.5 lg:w-full"}
                      type={"password"}
                      {...field}
                      placeholder="**********"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="otp"
              render={({ field }) => (
                <FormItem className="mt-4 flex flex-col">
                  <FormLabel>OTP</FormLabel>
                  <FormControl>
                    <Input
                      className={"px-4 py-2.5 lg:w-full"}
                      {...field}
                      placeholder="Enter OTP"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit" className={"mt-6 w-full"}>
              {isPending ? <Throbber /> : "Change Password"}
            </Button>
          </Form>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
